const mapChartDataFromApi = (apiItems: ApiChartPoint[]): ChartPoint[] => {
  return apiItems.map((point) => ({
    date: new Date(point.label * 1000),
    pointIndex: point.x,
    price: point.y,
  }));
};

export default mapChartDataFromApi;
